import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		stepHeaderMobile: 'py-2 flex items-center justify-between border-t-[0.15rem] border-white list-none',
		stepContent:
			'max-h-full grid grid-cols-4 self-center gap-2 max-w-[65rem] transition-opacity duration-500 ease-in-out items-center',
	},
})

export type StepVariants = VariantProps<typeof styles>

